﻿/* ============================================================
   LOYWIS Cart â€" AJAX cart logic
   Handles: qty update, remove, add, free shipping progress,
            coupon redirect, WA message builder,
            saved for later (localStorage), delivery date,
            toast notifications, recommendations add to cart
   ============================================================ */

(function () {
  'use strict';

  /* â"€â"€ Helpers â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€ */

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }

  /* â"€â"€ Confetti burst â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€ */

  function launchConfetti() {
    const canvas = document.createElement('canvas');
    canvas.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:99999';
    canvas.width  = window.innerWidth;
    canvas.height = window.innerHeight;
    document.body.appendChild(canvas);

    const ctx    = canvas.getContext('2d');
    const colors = ['#C4952A','#D4A845','#B8891F','#F0C93A','#1B7F4F','#25D366','#fff','#FAF7F2'];
    const shapes = ['rect','circle'];
    const count  = 120;

    const particles = Array.from({ length: count }, () => ({
      x:      Math.random() * canvas.width,
      y:      Math.random() * canvas.height * 0.4 - canvas.height * 0.1,
      w:      Math.random() * 10 + 5,
      h:      Math.random() * 6 + 3,
      color:  colors[Math.floor(Math.random() * colors.length)],
      shape:  shapes[Math.floor(Math.random() * shapes.length)],
      angle:  Math.random() * Math.PI * 2,
      spin:   (Math.random() - 0.5) * 0.2,
      vx:     (Math.random() - 0.5) * 6,
      vy:     Math.random() * 4 + 2,
      alpha:  1,
      decay:  Math.random() * 0.012 + 0.008
    }));

    let frame;
    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      let alive = false;
      particles.forEach(p => {
        if (p.alpha <= 0) return;
        alive = true;
        p.x     += p.vx;
        p.y     += p.vy;
        p.vy    += 0.12;           // gravity
        p.vx    *= 0.99;
        p.angle += p.spin;
        p.alpha -= p.decay;

        ctx.save();
        ctx.globalAlpha = Math.max(0, p.alpha);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.angle);
        ctx.fillStyle = p.color;
        if (p.shape === 'circle') {
          ctx.beginPath();
          ctx.arc(0, 0, p.w / 2, 0, Math.PI * 2);
          ctx.fill();
        } else {
          ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        }
        ctx.restore();
      });

      if (alive) {
        frame = requestAnimationFrame(draw);
      } else {
        canvas.remove();
      }
    }
    draw();

    // safety cleanup after 4s
    setTimeout(() => { cancelAnimationFrame(frame); canvas.remove(); }, 4000);
  }

  function formatINR(paise) {
    return '\u20B9' + (paise / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  /* â"€â"€ Toast â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€ */

  let toastTimer;
  function showToast(msg, green) {
    let el = qs('.lw-cart-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'lw-cart-toast';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.toggle('lw-cart-toast--green', !!green);
    el.classList.add('lw-cart-toast--show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('lw-cart-toast--show'), 2800);
  }

  /* â"€â"€ Cart AJAX helpers â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€ */

  function cartChange(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    }).then(r => r.json());
  }

  function cartAdd(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(r => r.json());
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());
  }

  /* â"€â"€ Summary updater â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€ */

  function updateSummary(cart) {
    const threshold = parseInt(qs('[data-lw-shipping-threshold]')?.dataset?.lwShippingThreshold || '75000', 10);

    // item count (page badge: "N items")
    const countBadge = qs('[data-lw-item-count]');
    if (countBadge) countBadge.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');

    // Header cart badge - keep in sync with live cart
    qsa('.lw-hdr__cart-count, [data-lw-cart-count], .cart-count-bubble, .cart-badge, [data-cart-count]').forEach(el => {
      if (cart.item_count > 0) {
        el.textContent = cart.item_count > 99 ? '99+' : cart.item_count;
        el.hidden = false;
        el.style.display = '';
      } else {
        el.hidden = true;
      }
    });

    // Notify other listeners (e.g. header script in another section) that cart changed
    window.dispatchEvent(new CustomEvent('lw:cart-changed', { detail: cart }));

    // compare-at total (paise)
    // /cart.js line items do NOT expose compare_at_price, so the cart section
    // emits a variant_id -> compare-at (paise) map that we read here.
    let compareMap = {};
    try { compareMap = JSON.parse(qs('[data-lw-compare-map]')?.dataset?.lwCompareMap || '{}'); } catch (e) {}
    let comparePaise = 0;
    cart.items.forEach(item => {
      const cp = compareMap[item.variant_id] || 0;
      comparePaise += (cp > item.price ? cp : item.price) * item.quantity;
    });

    const subtotal   = cart.total_price;                   // paise
    const discount   = Math.max(0, comparePaise - subtotal);
    const deliveryCharge = parseInt(qs('[data-lw-delivery-charge]')?.dataset?.lwDeliveryCharge || '9900', 10);
    const delivery   = 0;   // Delivery hidden in cart; real charge applied at checkout   // â‚¹99 delivery fee in paise
    const couponAmt  = getLiveCouponDiscount(subtotal);
    const grand      = subtotal - couponAmt + delivery;
    const totalSave  = comparePaise - grand;

    setVal('[data-lw-mrp]',      formatINR(comparePaise));
    setVal('[data-lw-discount]', discount > 0 ? '-' + formatINR(discount) : '\u20B90');
    setVal('[data-lw-delivery]', delivery === 0 ? 'FREE \uD83C\uDF89' : formatINR(delivery));
    setVal('[data-lw-coupon-discount]', couponAmt > 0 ? '-' + formatINR(couponAmt) : formatINR(0));
    setVal('[data-lw-grand]',    formatINR(grand));
    setVal('[data-lw-savings]',  formatINR(Math.max(0, totalSave)));
    setVal('[data-lw-mobile-total]', formatINR(grand));

    // row labels
    const mrpRow = qs('[data-lw-mrp-label]');
    if (mrpRow) mrpRow.textContent = 'MRP (' + cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '') + ')';

    // free shipping progress bar
    updateShippingBar(subtotal, threshold);

    // savings banner
    const savingsBanner = qs('[data-lw-savings-wrap]');
    if (savingsBanner) savingsBanner.style.display = totalSave > 0 ? 'flex' : 'none';

    // b2g1 strip
    const b2g1Strip = qs('[data-lw-b2g1-strip]');
    if (b2g1Strip) b2g1Strip.style.display = cart.item_count >= 2 ? 'flex' : 'none';

    // empty state
    const emptyEl = qs('[data-lw-cart-empty]');
    const itemsEl = qs('[data-lw-cart-items]');
    const stepsEl = qs('[data-lw-cart-steps]');
    const shippingEl = qs('[data-lw-shipping-bar]');
    const mobileBar  = qs('.lw-cart-mobile-bar');

    if (cart.item_count === 0) {
      if (emptyEl)    emptyEl.classList.add('lw-cart-empty--show');
      if (itemsEl)    itemsEl.style.display = 'none';
      if (stepsEl)    stepsEl.style.display = 'none';
      if (shippingEl) shippingEl.style.display = 'none';
      if (b2g1Strip)  b2g1Strip.style.display = 'none';
      if (mobileBar)  mobileBar.style.display = 'none';
    } else {
      if (emptyEl)    emptyEl.classList.remove('lw-cart-empty--show');
      if (itemsEl)    itemsEl.style.display = '';
      if (stepsEl)    stepsEl.style.display = '';
      if (shippingEl) shippingEl.style.display = '';
      if (mobileBar)  mobileBar.style.display = '';
    }
  }

  function setVal(sel, val) {
    qsa(sel).forEach(el => { el.textContent = val; });
  }

  function updateShippingBar(subtotalPaise, thresholdPaise) {
    const bar   = qs('[data-lw-shipping-bar]');
    const fill  = qs('[data-lw-progress-fill]');
    const pct   = qs('[data-lw-progress-pct]');
    const msg   = qs('[data-lw-shipping-msg]');
    if (!bar) return;

    const ratio      = Math.min(1, subtotalPaise / thresholdPaise);
    const pctVal     = Math.round(ratio * 100);
    const remaining  = thresholdPaise - subtotalPaise;

    if (fill) fill.style.width = pctVal + '%';
    if (pct)  pct.textContent  = pctVal + '%';

    if (subtotalPaise >= thresholdPaise) {
      bar.classList.add('lw-cart-shipping-bar--free');
      if (fill) fill.classList.add('lw-cart-progress-fill--full');
      if (msg)  msg.innerHTML = 'You unlocked <strong>FREE Delivery!</strong> \uD83C\uDF89';
    } else {
      bar.classList.remove('lw-cart-shipping-bar--free');
      if (fill) fill.classList.remove('lw-cart-progress-fill--full');
      if (msg)  msg.innerHTML = 'Add <strong>' + formatINR(remaining) + '</strong> more for <strong>FREE Delivery!</strong>';
    }
  }

  /* â"€â"€ Coupon (stored in sessionStorage for display) â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€ */
  // Real discount applied via /checkout?discount=CODE

  function getLiveCouponDiscount(subtotalPaise) {
    const code = sessionStorage.getItem('lw_coupon_code');
    const pct  = parseInt(sessionStorage.getItem('lw_coupon_pct') || '0', 10);
    if (!code || pct <= 0) return 0;
    return Math.round(subtotalPaise * pct / 100);
  }

  function applyQuickCoupon(code) {
    const input     = qs('[data-lw-coupon-input]');
    if (input) input.value = code;
    applyCouponCode(code);
  }

  function applyCouponCode(code) {
    const input      = qs('[data-lw-coupon-input]');
    const errorEl    = qs('[data-lw-coupon-error]');
    const appliedEl  = qs('[data-lw-coupon-applied]');
    const codeNameEl = qs('[data-lw-coupon-code-name]');
    const inputWrap  = qs('[data-lw-coupon-input-wrap]');
    const quickCodes = qs('[data-lw-quick-codes]');
    const couponRow  = qs('[data-lw-coupon-row]');
    const couponRowCode = qs('[data-lw-coupon-row-code]');

    if (!code) return;
    code = code.toUpperCase().trim();

    // Merchant-configured codes come from section data
    const codesEl = qs('[data-lw-coupon-codes]');
    let validCodes = {};
    if (codesEl) {
      try { validCodes = JSON.parse(codesEl.dataset.lwCouponCodes); } catch(e) {}
    }

    if (validCodes[code] === undefined) {
      if (errorEl) { errorEl.textContent = 'Invalid coupon code.'; errorEl.classList.add('lw-cart-coupon__error--show'); }
      if (input) { input.style.borderColor = '#E05020'; setTimeout(() => { input.style.borderColor = ''; }, 1200); }
      return;
    }

    sessionStorage.setItem('lw_coupon_code', code);
    sessionStorage.setItem('lw_coupon_pct',  String(validCodes[code]));

    if (errorEl)    errorEl.classList.remove('lw-cart-coupon__error--show');
    if (inputWrap)  inputWrap.style.display = 'none';
    if (quickCodes) quickCodes.style.display = 'none';
    if (appliedEl)  { appliedEl.classList.add('lw-cart-coupon__applied--show'); }
    if (codeNameEl) {
      const pct = validCodes[code];
      codeNameEl.textContent = code + (pct > 0 ? ' \u2013 ' + pct + '% off!' : ' \u2013 Buy 2 Get 1 Free!');
    }
    if (couponRow)     couponRow.style.display = 'flex';
    if (couponRowCode) couponRowCode.textContent = code;

    fetchCart().then(cart => updateSummary(cart));
    launchConfetti();
    showToast('\uD83C\uDF89 Coupon ' + code + ' applied!', true);
  }

  function removeCoupon() {
    sessionStorage.removeItem('lw_coupon_code');
    sessionStorage.removeItem('lw_coupon_pct');
    const input     = qs('[data-lw-coupon-input]');
    const appliedEl = qs('[data-lw-coupon-applied]');
    const inputWrap = qs('[data-lw-coupon-input-wrap]');
    const quickCodes = qs('[data-lw-quick-codes]');
    const couponRow  = qs('[data-lw-coupon-row]');
    if (input)      input.value = '';
    if (appliedEl)  appliedEl.classList.remove('lw-cart-coupon__applied--show');
    if (inputWrap)  inputWrap.style.display = '';
    if (quickCodes) quickCodes.style.display = '';
    if (couponRow)  couponRow.style.display = 'none';
    fetchCart().then(cart => updateSummary(cart));
  }

  /* â"€â"€ Checkout â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€ */

  function buildCheckoutUrl() {
    const code = sessionStorage.getItem('lw_coupon_code');
    return code ? '/checkout?discount=' + encodeURIComponent(code) : '/checkout';
  }

  function handleCheckout() {
    window.location.href = buildCheckoutUrl();
  }

  /* â"€â"€ WA checkout message â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€ */

  function buildWaMessage(cart, waNumber, prefix) {
    let lines = [(prefix || 'Hello! I want to order:'), ''];
    cart.items.forEach((item, i) => {
      lines.push((i + 1) + '. ' + item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' (' + item.variant_title + ')' : '') + ' x' + item.quantity + ' - ' + formatINR(item.line_price));
    });
    lines.push('');
    lines.push('Total: ' + formatINR(cart.total_price));
    const code = sessionStorage.getItem('lw_coupon_code');
    if (code) lines.push('Coupon: ' + code);
    return 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(lines.join('\n'));
  }

  function handleWaCheckout() {
    const waEl = qs('[data-lw-wa-number]');
    const waNumber = waEl ? waEl.dataset.lwWaNumber.replace(/\D/g, '') : '';
    const waPrefix = waEl ? (waEl.dataset.lwWaPrefix || '') : '';
    if (!waNumber) return;
    fetchCart().then(cart => {
      window.open(buildWaMessage(cart, waNumber, waPrefix), '_blank');
    });
  }

  function handleWaAskItem(productTitle, waNumber, waPrefix) {
    const msg = (waPrefix || 'Hello! I want to ask about:') + '\n' + productTitle;
    window.open('https://wa.me/' + waNumber.replace(/\D/g, '') + '?text=' + encodeURIComponent(msg), '_blank');
  }

  /* â"€â"€ Qty controls â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€ */

  function changeQty(itemEl, delta) {
    const key     = itemEl.dataset.lwKey;
    const qtyEl   = qs('[data-lw-qty-num]', itemEl);
    const minusBtn = qs('[data-lw-qty-minus]', itemEl);
    if (!key || !qtyEl) return;

    const current  = parseInt(qtyEl.value, 10);
    const newQty   = Math.max(1, Math.min(10, current + delta));
    if (newQty === current) return;

    qtyEl.value = newQty;
    if (minusBtn) minusBtn.disabled = newQty <= 1;

    cartChange(key, newQty).then(cart => {
      // update line price for this item
      const lineItem = cart.items.find(i => i.key === key);
      if (lineItem) {
        const priceEl = qs('[data-lw-line-price]', itemEl);
        if (priceEl) priceEl.textContent = formatINR(lineItem.line_price);
      }
      updateSummary(cart);
    }).catch(() => {
      qtyEl.value = current;
      showToast('Could not update quantity. Please try again.');
    });
  }

  /* â"€â"€ Remove item â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€ */

  function removeItem(itemEl) {
    const key = itemEl.dataset.lwKey;
    if (!key) return;

    itemEl.style.maxHeight = itemEl.offsetHeight + 'px';
    itemEl.classList.add('lw-cart-item--removing');

    setTimeout(() => {
      itemEl.style.maxHeight = '0';
      itemEl.style.padding   = '0';
      itemEl.style.margin    = '0';
      itemEl.style.border    = 'none';
      itemEl.style.overflow  = 'hidden';
      itemEl.style.transition = 'max-height .35s ease, padding .35s, margin .35s, border .35s';
    }, 280);

    setTimeout(() => {
      itemEl.remove();
      cartChange(key, 0).then(cart => {
        updateSummary(cart);
      }).catch(() => {
        showToast('Could not remove item. Please try again.');
      });
    }, 650);
  }

  /* â"€â"€ Save for later (localStorage) â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€ */

  const SAVED_KEY = 'lw_saved_later';

  function getSaved() {
    try { return JSON.parse(localStorage.getItem(SAVED_KEY) || '[]'); } catch(e) { return []; }
  }
  function setSaved(arr) { localStorage.setItem(SAVED_KEY, JSON.stringify(arr)); }

  function saveForLater(itemEl) {
    const key     = itemEl.dataset.lwKey;
    const varId   = itemEl.dataset.lwVariantId;
    const title   = itemEl.dataset.lwTitle;
    const price   = itemEl.dataset.lwPrice;
    const img     = itemEl.dataset.lwImg;
    const url     = itemEl.dataset.lwUrl;

    const saved = getSaved();
    if (!saved.find(i => i.key === key)) {
      saved.push({ key, varId, title, price, img, url });
      setSaved(saved);
    }
    removeItem(itemEl);
    renderSavedSection();
    showToast('\u2661 Saved for later!');
  }

  function renderSavedSection() {
    const wrap      = qs('[data-lw-saved-scroll]');
    const countEl   = qs('[data-lw-saved-count]');
    const section   = qs('[data-lw-saved-section]');
    const moveAllEl = qs('[data-lw-saved-move-all]');
    if (!wrap) return;

    const saved = getSaved();

    if (countEl) countEl.textContent = saved.length + ' item' + (saved.length !== 1 ? 's' : '');
    if (section) section.style.display = saved.length > 0 ? '' : 'none';
    if (moveAllEl) moveAllEl.style.display = saved.length > 1 ? '' : 'none';

    wrap.innerHTML = '';
    saved.forEach(item => {
      const card = document.createElement('div');
      card.className = 'lw-cart-saved-card';
      card.dataset.lwSavedKey = item.key;
      card.innerHTML = `
        <div class="lw-cart-saved-card__img">
          ${item.img
            ? `<img src="${item.img}" alt="${item.title}" loading="lazy">`
            : `<span class="lw-cart-saved-card__img-placeholder">\uD83D\uDC8E</span>`}
        </div>
        <div class="lw-cart-saved-card__info">
          <div class="lw-cart-saved-card__name">${item.title}</div>
          <div class="lw-cart-saved-card__price">${formatINR(parseInt(item.price, 10))}</div>
        </div>
        <button class="lw-cart-saved-card__move-btn">+ Move to Cart</button>
      `;
      qs('.lw-cart-saved-card__move-btn', card).addEventListener('click', () => moveToCart(item));
      wrap.appendChild(card);
    });
  }

  function moveToCart(item) {
    cartAdd(item.varId, 1).then(() => {
      const saved = getSaved().filter(i => i.key !== item.key);
      setSaved(saved);
      window.location.reload();
    }).catch(() => showToast('Could not add item. Please try again.'));
  }

  function moveAllToCart() {
    const saved = getSaved();
    if (!saved.length) return;
    Promise.all(saved.map(item => cartAdd(item.varId, 1))).then(() => {
      setSaved([]);
      window.location.reload();
    }).catch(() => showToast('Could not move all items. Please try again.'));
  }

  /* â"€â"€ Add recommendation to cart â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€ */

  function addRecToCart(btn, variantId, productTitle) {
    btn.textContent = 'Adding\u2026';
    btn.classList.add('lw-cart-rec-card__add-btn--loading');
    btn.disabled = true;
    cartAdd(variantId, 1).then(() => {
      btn.textContent = '\u2714 Added!';
      btn.style.background = 'var(--lw-gold)';
      btn.style.color = '#fff';
      fetchCart().then(cart => updateSummary(cart));
      showToast(productTitle + ' added to cart!', true);
      setTimeout(() => {
        btn.textContent = '+ Add to Cart';
        btn.style.background = '';
        btn.style.color = '';
        btn.disabled = false;
        btn.classList.remove('lw-cart-rec-card__add-btn--loading');
      }, 2000);
    }).catch(() => {
      btn.textContent = '+ Add to Cart';
      btn.disabled = false;
      btn.classList.remove('lw-cart-rec-card__add-btn--loading');
      showToast('Could not add item. Please try again.');
    });
  }

  /* â"€â"€ Delivery date â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€ */

  function setDeliveryDate() {
    const els = qsa('[data-lw-delivery-date]');
    if (!els.length) return;
    const bufferDays = parseInt(els[0].dataset.lwDeliveryDays || '3', 10);
    const d = new Date();
    d.setDate(d.getDate() + bufferDays);
    const formatted = d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
    els.forEach(el => { el.textContent = formatted; });
  }

  /* â"€â"€ Restore applied coupon on page load â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€ */

  function restoreCoupon() {
    const code = sessionStorage.getItem('lw_coupon_code');
    if (!code) return;
    const inputWrap  = qs('[data-lw-coupon-input-wrap]');
    const appliedEl  = qs('[data-lw-coupon-applied]');
    const codeNameEl = qs('[data-lw-coupon-code-name]');
    const quickCodes = qs('[data-lw-quick-codes]');
    const couponRow  = qs('[data-lw-coupon-row]');
    const couponRowCode = qs('[data-lw-coupon-row-code]');
    const pct = parseInt(sessionStorage.getItem('lw_coupon_pct') || '0', 10);

    if (inputWrap)  inputWrap.style.display = 'none';
    if (quickCodes) quickCodes.style.display = 'none';
    if (appliedEl)  appliedEl.classList.add('lw-cart-coupon__applied--show');
    if (codeNameEl) codeNameEl.textContent = code + (pct > 0 ? ' â€" ' + pct + '% off!' : ' â€" Buy 2 Get 1 Free!');
    if (couponRow)     couponRow.style.display = 'flex';
    if (couponRowCode) couponRowCode.textContent = code;
  }

  /* â"€â"€ Event delegation â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€ */

  document.addEventListener('click', function (e) {
    const t = e.target;

    // Qty minus
    if (t.closest('[data-lw-qty-minus]')) {
      changeQty(t.closest('[data-lw-cart-item]'), -1);
    }
    // Qty plus
    if (t.closest('[data-lw-qty-plus]')) {
      changeQty(t.closest('[data-lw-cart-item]'), 1);
    }
    // Remove
    if (t.closest('[data-lw-remove-btn]')) {
      removeItem(t.closest('[data-lw-cart-item]'));
    }
    // Save for later
    if (t.closest('[data-lw-save-btn]')) {
      saveForLater(t.closest('[data-lw-cart-item]'));
    }
    // WA ask about item
    if (t.closest('[data-lw-item-wa-btn]')) {
      const btn     = t.closest('[data-lw-item-wa-btn]');
      const waEl    = qs('[data-lw-wa-number]');
      const waNum   = waEl ? waEl.dataset.lwWaNumber : '';
      const waPfx   = waEl ? (waEl.dataset.lwWaPrefix || '') : '';
      const title   = btn.dataset.lwItemTitle || '';
      handleWaAskItem(title, waNum, waPfx);
    }
    // Checkout btn
    if (t.closest('[data-lw-checkout-btn]')) {
      e.preventDefault();
      handleCheckout();
    }
    // WA checkout
    if (t.closest('[data-lw-wa-checkout-btn]')) {
      e.preventDefault();
      handleWaCheckout();
    }
    // Coupon apply
    if (t.closest('[data-lw-coupon-apply-btn]')) {
      const input = qs('[data-lw-coupon-input]');
      applyCouponCode(input ? input.value : '');
    }
    // Coupon remove
    if (t.closest('[data-lw-coupon-remove]')) {
      removeCoupon();
    }
    // Quick chip
    if (t.closest('[data-lw-quick-chip]')) {
      applyQuickCoupon(t.closest('[data-lw-quick-chip]').dataset.lwQuickChip);
    }
    // Rec add to cart
    if (t.closest('[data-lw-rec-add-btn]')) {
      const btn  = t.closest('[data-lw-rec-add-btn]');
      const varId = btn.dataset.lwRecVariant;
      const name  = btn.dataset.lwRecName || '';
      addRecToCart(btn, varId, name);
    }
    // Move all to cart
    if (t.closest('[data-lw-saved-move-all]')) {
      e.preventDefault();
      moveAllToCart();
    }
  });

  // Coupon input â€" Enter key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-lw-coupon-input]')) {
      applyCouponCode(e.target.value);
    }
  });

  /* â"€â"€ Init â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€ */

  document.addEventListener('DOMContentLoaded', function () {
    setDeliveryDate();
    restoreCoupon();
    renderSavedSection();
    fetchCart().then(cart => updateSummary(cart));
  });

})();
